import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { ServiceCategoryIcon } from './ServiceCategoryIcon';
import { serviceCategories } from '../data/serviceCategories';
import { business } from '../data/site';
const PREVIEW_COUNT = 5;
export function Services() {
  return <section id="services" className="w-full bg-chalk py-20 lg:py-28" data-id="element-343" data-mp="18u67ybs39gpe">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-344" data-mp="13wecx8w5degz">
        <div className="flex flex-col gap-6 border-b border-black/10 pb-8 md:flex-row md:items-end md:justify-between" data-id="element-345" data-mp="13xxxhbou6bok">
          <div data-id="element-346" data-mp="u61oh5l7p15k">
            <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-347" data-mp="u5jtecaacsz8">
              What we do
            </p>
            <h2 className="mt-4 max-w-[620px] font-display text-[34px] font-extrabold leading-[1.08] tracking-[-0.02em] text-ink sm:text-[42px]" data-id="element-348" data-mp="q6183fejyfvv">
              Auto Repair Services in Oak Ridge, TN
            </h2>
            <p className="mt-4 max-w-[560px] text-[16px] leading-relaxed text-steel/75" data-id="element-349" data-mp="g7262foalihu">
              Diagnostics, maintenance and repair across the systems on your
              vehicle — with the same process every time.
            </p>
          </div>
          <Link to="/services" className="inline-flex shrink-0 items-center gap-2 self-start whitespace-nowrap rounded-md border border-ink/20 px-5 py-3 text-sm font-semibold text-ink transition-colors duration-150 ease-out hover:border-ink md:self-auto" data-id="element-350" data-mp="2xckq3rf8rsx8">
            View All Services
            <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-351" data-mp="3u0qx2kzmyxeo" />
          </Link>
        </div>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-352" data-mp="3g1r9lgnv0ok3">
          {serviceCategories.map(category => {
          const preview = category.services.slice(0, PREVIEW_COUNT);
          const remaining = category.services.length - preview.length;
          return <li key={category.slug} className="flex" data-id="element-353" data-mp="29n04f0rpehk9">
                <Link to={`/services/${category.slug}`} className="group flex w-full flex-col rounded-lg border border-black/10 bg-white p-6 transition-colors duration-150 ease-out hover:border-ink/40" data-id="element-354" data-mp="1pjuhl9nv90ez">
                  <ServiceCategoryIcon name={category.icon} className="h-6 w-6 text-brand-dark" data-id="element-355" data-mp="1gpxzq71qia5d" />
                  <h3 className="mt-4 font-display text-[19px] font-bold leading-snug tracking-tight text-ink" data-id="element-356" data-mp="16tuxz2asodiy">
                    {category.name}
                  </h3>
                  <p className="mt-2 text-[14px] leading-relaxed text-steel/70" data-id="element-357" data-mp="xswsefkpjxy9">
                    {category.blurb}
                  </p>

                  <ul className="mt-4 space-y-1.5" data-id="element-358" data-mp="suv7rq7mvqko">
                    {preview.map(service => <li key={service.slug} className="text-[13.5px] leading-snug text-steel/75" data-id="element-359" data-mp="2s5wacfck948p">
                        {service.name}
                      </li>)}
                    {remaining > 0 && <li className="text-[13.5px] font-medium text-steel/50" data-id="element-360" data-mp="2zpf51iv62lx4">
                        +{remaining} more
                      </li>}
                  </ul>

                  <span className="mt-auto flex items-center gap-1.5 pt-5 text-[12.5px] font-bold uppercase tracking-[0.08em] text-brand-dark" data-id="element-361" data-mp="39f8cq8s6ugw3">
                    View category
                    <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-362" data-mp="2gr2r7jtb8nv7" />
                  </span>
                </Link>
              </li>;
        })}
        </ul>

        <div className="mt-10 flex flex-col gap-4 border-t border-black/10 pt-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-363" data-mp="zeyk0lbxhi7">
          <p className="max-w-[520px] text-[14.5px] leading-relaxed text-steel/65" data-id="element-364" data-mp="508muv2ooybm">
            Not sure which category your concern falls under? Call the shop and
            describe what the vehicle is doing.{' '}
            <Link to="/specials" className="font-semibold text-brand-dark hover:underline" data-id="element-365" data-mp="3utk2xk72xpcq">
              See current specials
            </Link>
            .
          </p>
          <a href={business.phoneHref} className="inline-flex shrink-0 items-center justify-center gap-3 self-start whitespace-nowrap rounded-md bg-brand px-6 py-3.5 font-display text-[17px] font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light sm:self-auto" data-id="element-366" data-mp="mjh3mhvvihby">
            <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-367" data-mp="ra79dw87om76" />
            Call {business.phone}
          </a>
        </div>
      </div>
    </section>;
}